import ProfileTypes from './profile.types';
import {
	setProfileData,
	showHideUserType,
	handleInputChange,
} from './profile.utils';
import { initialProfileState, resetData } from '../initialState';

export const profileState = (state = initialProfileState, action = {}) => {
	switch (action.type) {
		case ProfileTypes.RESET_STATE_VAL:
			return Object.assign({}, state, { ...resetData });
		case ProfileTypes.UPDATE_PROFILE_DETAILS.SUCCESS:
			return Object.assign({}, state, { ...action.payload, success: true });
		case ProfileTypes.UPDATE_COACH_STREAM.PENDING:
			return Object.assign({}, state, { ...action.payload, success: true });
		case ProfileTypes.CHANGE_PHONE:
			return Object.assign({}, state, { phone: action.payload });
		case ProfileTypes.CHANGE_EMAIL:
			return Object.assign({}, state, { email: action.payload });
		case ProfileTypes.CHANGE_FULL_NAME:
			return Object.assign({}, state, { fullName: action.payload });
		case ProfileTypes.HANDLE_DATE_CHANGE:
			return Object.assign({}, state, { birthDate: action.payload });
		case ProfileTypes.HANDLE_GRADUATE_DATE_CHANGE:
			return Object.assign({}, state, { graduateYear: action.payload });
		case ProfileTypes.GET_PROFILE_DETAILS.SUCCESS:
			return Object.assign({}, state, { ...setProfileData(action.payload) });
		case ProfileTypes.SHOW_HIDE_USER_TYPE:
			return Object.assign({}, state, { ...showHideUserType(action.payload) });
		case ProfileTypes.HANDLE_INPUT_CHANGE:
			return Object.assign({}, state, {
				...handleInputChange(action.payload, state.aspectToDevelop),
			});
		case ProfileTypes.TOGGLE_PROFILE_EDIT:
			return Object.assign({}, state, { editProfile: !state.editProfile });
		case ProfileTypes.VERIFY_MOBILE_OTP.SUCCESS:
			return Object.assign({}, state, { isMobVerified: true });
		case ProfileTypes.SEND_MOBILE_OTP.SUCCESS:
			return Object.assign({}, state, { isOtpSent: true });
		case ProfileTypes.SUBCRIBE_FOR_UPDATES.SUCCESS:
			return Object.assign({}, state, { isSubscribe: action.payload });
		case ProfileTypes.CHILD_STATUS:
			return Object.assign({}, state, { childStatus: action.payload });
		case ProfileTypes.SHOW_SUBSCRIBE:
			return Object.assign({}, state, { showSubscribe: action.payload });
		case ProfileTypes.SHOW_USER_MODAL:
			return Object.assign({}, state, { getUserInfo: action.payload });
		case ProfileTypes.SHOW_VERIFY_MOB:
			return Object.assign({}, state, { showVerifyMob: action.payload });

		default:
			return state;
	}
};

